// extracted by mini-css-extract-plugin
export default {"pagination":"checkbox_pagination__GYqUs","page-link":"checkbox_page-link__Ghkrd","checkbox":"checkbox_checkbox__zSXQE","input":"checkbox_input__1ws5i"};